<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Copy Time Table</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-row dense>
                <!-- FROM -->
                <v-col cols="12" md="6">
                    <v-card class="pa-4">
                        <v-toolbar flat dense class="toolbar_1">
                            <v-toolbar-title>From</v-toolbar-title>
                        </v-toolbar>
                        <v-autocomplete dense rounded required v-model="from_ay" return-object :items="ay_std_div_list"
                            item-text="ay" label="Academic Year" outlined
                            @change="getFromStd(); getFromTimeTableVersion()" persistent-hint
                            hint="Please Select Academic Year" />
                        <v-autocomplete dense rounded required v-model="from_std" return-object
                            :items="from_std_div_list" item-text="std" label="Standard" outlined @change="getFromDiv()"
                            persistent-hint hint="Select Standard " />

                        <v-autocomplete color="#0F2027" dense rounded required v-model="from_division" return-object
                            :items="from_div_list" item-text="div_name" label="Division" outlined persistent-hint
                            hint="Select Division" />

                        <v-autocomplete rounded dense v-model="from_version" :items="from_tt_version_list"
                            item-text="name" item-value="id" label="Version" outlined />
                    </v-card>
                </v-col>

                <!-- TO -->
                <v-col cols="12" md="6">
                    <v-card class="pa-4">
                        <v-toolbar flat dense class="toolbar_2">
                            <v-toolbar-title>To</v-toolbar-title>
                        </v-toolbar>

                        <v-autocomplete dense rounded required v-model="to_ay" return-object :items="ay_std_div_list"
                            item-text="ay" label="Academic Year" outlined @change="getToStd(); getToTimeTableVersion()"
                            persistent-hint hint="Please Select Academic Year" />

                        <v-autocomplete dense rounded required v-model="to_std" return-object :items="to_std_div_list"
                            item-text="std" label="Standard" outlined @change="getToDiv()" persistent-hint
                            hint="Select Standard " />

                        <v-autocomplete color="#0F2027" dense rounded required v-model="to_division" return-object
                            :items="to_div_list" item-text="div_name" label="Division" outlined persistent-hint
                            hint="Select Division" />

                        <v-autocomplete rounded dense v-model="to_version" :items="to_tt_version_list" item-text="name"
                            item-value="id" label="Version" outlined />
                    </v-card>
                </v-col>
            </v-row>

            <v-row justify="center">
                <v-btn class="button" :loading="copying" @click="copyTimeTable">
                    Copy Time Table
                </v-btn>
            </v-row>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        from_ay: null,
        from_std: null,
        from_division: null,
        from_version: null,

        to_ay: null,
        to_std: null,
        to_division: null,
        to_version: null,

        to_division_list: [],
        from_division_list: [],

        from_tt_version_list: [],
        to_tt_version_list: [],

        from_std_div_list: [],
        to_std_div_list: [],

        from_div_list: [],
        to_div_list: [],

        ay_std_div_list: [],
        copying: false,
        ay_std_data: null,
        snackbar: false,
        snackbar_msg: "",
        color: "",
        overlay: false,
        from_slot_list: [],
        to_slot_list: [],
    }),
    watch: {
        to_ay() {
            if (this.to_ay != null && this.to_version != null) {
                this.getSlot(this.to_ay, this.to_version, "to");
            }
        },

        to_version() {
            if (this.to_ay != null && this.to_version != null) {
                this.getSlot(this.to_ay, this.to_version, "to");
            }
        },

        from_ay() {
            if (this.from_ay != null && this.from_version != null) {
                this.getSlot(this.from_ay, this.from_version, "from");
            }
        },

        from_version() {
            if (this.from_ay != null && this.from_version != null) {
                this.getSlot(this.from_ay, this.from_version, "from");
            }
        },
    },
    methods: {
        copyTimeTable() {
            if (!this.from_ay || !this.from_std || !this.from_division || !this.from_version) {
                alert("Please select all From details.");
                return;
            }

            if (!this.to_ay || !this.to_std || !this.to_division || !this.to_version) {
                alert("Please select all To details.");
                return;
            }

            if (
                this.from_ay.ay_id == this.to_ay.ay_id &&
                this.from_std.std_id == this.to_std.std_id &&
                this.from_division.div_off_id == this.to_division.div_off_id &&
                this.from_version == this.to_version
            ) {
                alert("From and To details cannot be same.");
                return;
            }

            const formData = {
                from_ay: this.from_ay.ay_id,
                from_std: this.from_std.std_id,
                from_div_off: this.from_division.div_off_id,
                from_version: this.from_version,

                to_ay: this.to_ay.ay_id,
                to_std: this.to_std.std_id,
                to_div_off: this.to_division.div_off_id,
                to_version: this.to_version
            };

            console.log("Copy Time Table Data:", formData);

            this.copying = true;

            axios
                .post("/timeTable/copyTimeTable", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("success",res.data.snackbar)
                    } else {
                        this.showSnackbar("error",res.data.snackbar)
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.showSnackbar("error","Something went wrong !!!")
                })
                .finally(() => {
                    this.copying = false;
                });
        },
        getFromTimeTableVersion() {
            if (!this.from_ay) {
                this.from_tt_version_list = [];
                return;
            }
            this.from_std = null
            this.from_division = null
            const data = {
                ay: this.from_ay.ay,
            };

            axios
                .post("/timeTable/getTTVersion", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.from_tt_version_list = res.data.tt_version_list || [];
                    } else {
                        this.from_tt_version_list = [];
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                });
        },

        getToTimeTableVersion() {
            if (!this.to_ay) {
                this.to_tt_version_list = [];
                return;
            }

            const data = {
                ay: this.to_ay.ay,
            };

            axios
                .post("/timeTable/getTTVersion", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.to_tt_version_list = res.data.tt_version_list || [];
                    } else {
                        this.to_tt_version_list = [];
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                });
        },
        getSlot(ay, version_id, to_from) {
            if (to_from == "to") {
                this.to_slot_list = [];
            } else {
                this.from_slot_list = [];
            }

            const formData = {
                ay: ay.ay_id,
                timetableversionmaster_id: version_id,
            };

            axios
                .post("/timeTable/getSlot", formData)
                .then((res) => {
                    if (to_from == "to") {
                        this.to_slot_list = res.data.slot_list || [];
                    } else {
                        this.from_slot_list = res.data.slot_list || [];
                    }
                })
                .catch((error) => {
                    alert("Something went wrong!!!");
                    window.console.log(error);
                });
        },
        getFromStd() {
            this.from_div_list = null;
            this.from_std_div_list = this.from_ay.std_list;
        },
        getToStd() {
            this.to_div_list = null;
            this.to_std_div_list = this.to_ay.std_list;

        },
        getFromDiv() {
            this.from_div_list = [];
            this.from_division = null;

            if (!this.from_std) {
                return;
            }

            this.from_div_list = this.from_std.div_list || [];

            if (this.from_div_list.length == 0) {
                alert("No division found!!!");
                return;
            }

            this.from_division = this.from_div_list[0];
        },
        getToDiv() {
            this.to_div_list = [];
            this.to_division = null;

            if (!this.to_std) {
                return;
            }

            this.to_div_list = this.to_std.div_list || [];

            if (this.to_div_list.length == 0) {
                alert("No division found!!!");
                return;
            }

            this.to_division = this.to_div_list[0];
        },

        get_ay_std() {
            this.overlay = true;
            //api-1
            axios
                .post("/CommonAPI/get_ay_std_div_for_report_by_access")
                .then((res) => {
                    this.overlay = false;
                    this.ay_std_div_list = res.data.data;

                })
                .catch((error) => {
                    this.overlay = false;
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        this.get_ay_std();
    },
};
</script>
<style scoped></style>
